import {getTestProps} from '@benchling/js-test-utils';
import {Button, ButtonProps, Tooltip} from '@mantine/core';
import classNames from 'classnames';
import React from 'react';

import {getDisabledTooltipButtonProps} from 'lib/a11y/ButtonA11y';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import ModalAnchor from 'ui-library/ModalAnchor';

import SetValidationModal from './SetValidationModal';
import {validatableInputsToReadable} from './ValidatableInput';
import {ValidatableInput} from './ValidationConstants';

interface Props {
  className?: string;
  disabled?: boolean;
  modalWarningMessage?: string | null;
  size?: ButtonProps['size'];
  validatableInputs: Array<ValidatableInput>;
}

interface State {
  isModalOpen: boolean;
}

export default class SetValidationButton extends React.Component<Props, State> {
  static defaultProps = {
    disabled: false,
    size: 'xs',
  };

  override state: State = {
    isModalOpen: false,
  };

  _handleOpenModal = (): void => {
    this.setState({isModalOpen: true});
  };

  _handleCloseModal = (): void => {
    this.setState({isModalOpen: false});
  };

  override render(): JSX.Element {
    const noInputs = this.props.validatableInputs.length === 0;
    return (
      <div className={classNames(this.props.className, 'u-display-inline-block')}>
        <ModalAnchor open={this.state.isModalOpen}>
          <SetValidationModal
            onRequestClose={this._handleCloseModal}
            validatableInputs={this.props.validatableInputs}
            warningMessage={this.props.modalWarningMessage || null}
          />
        </ModalAnchor>
        <Tooltip
          events={{hover: true, focus: true, touch: true}}
          label={
            noInputs
              ? 'Set validation'
              : `Set validation on ${validatableInputsToReadable(this.props.validatableInputs, false)}`
          }
          withinPortal={true}
        >
          <Button
            size={this.props.size}
            variant="tertiary"
            {...getTestProps({component: 'SetValidationButton', element: 'validationButton'})}
            {...getDisabledTooltipButtonProps(this.props.disabled || noInputs, this._handleOpenModal, true)}
          >
            <BenchlingIcon icon="validation" />
          </Button>
        </Tooltip>
      </div>
    );
  }
}
